<template>
  <div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :width="dialogWidth" :before-close="closeDialog" :top="customTop">
      <el-form :model="form" :rules="rules" ref="form" label-width="180px" class="demo-ruleForm">
        <div v-for="(item, index) of dialogModel" :key="index + '_' + item.prop">
          <el-form-item v-if="!item.isHidden && item.type === 'el-input'" :label="item.label" :prop="item.prop">
            <el-input
              v-model="form[item.prop]"
              :placeholder="item.placeholder"
              :type="item.inputType || 'string'"
              :disabled="item.isDisabled"
              @input="changeInput($event, item)"
              :style="{ width: item.width || '300px' }"
            ></el-input>
            <span>{{ item.flag }}</span>
          </el-form-item>
          <el-form-item v-if="!item.isHidden && item.type === 'el-input-number'" :label="item.label" :prop="item.prop">
            <el-input-number v-model="form[item.prop]" :placeholder="item.placeholder" :disabled="item.isDisabled" :style="{ width: item.width || '300px' }" :min="item.min"></el-input-number>
          </el-form-item>
          <el-form-item v-if="!item.isHidden && item.type === 'el-select'" :label="item.label" :prop="item.prop">
            <el-select
              v-model="form[item.prop]"
              :placeholder="item.placeholder"
              :multiple="item.isMultiple"
              :collapse-tags="item.collapseTags"
              filterable
              @change="changeOption($event, item)"
              :style="{ width: item.width || '300px' }"
              :disabled="item.isDisabled"
              :clearable="item.clearable"
            >
              <el-option
                v-for="(optionItem, optionIndex) of item.options"
                :key="optionIndex"
                :label="optionItem.label || optionItem.name || optionItem.game_circle_name || optionItem.title"
                :value="optionItem.value || optionItem.id || optionItem.circle_id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="!item.isHidden && item.type === 'el-select-group'" :label="item.label" :prop="item.prop">
            <el-select v-model="form[item.prop]" :placeholder="item.placeholder" :multiple="item.isMultiple" :style="{ width: item.width || '300px' }">
              <el-option-group v-for="group in item.options" :key="group.label" :label="group.label">
                <el-option v-for="m in group.options" :key="m.value" :label="m.label" :value="m.value"> </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item v-if="!item.isHidden && item.type === 'el-date-picker'" :label="item.label" :prop="item.prop">
            <el-col :span="17">
              <el-date-picker
                :type="item.dateType ? item.dateType : 'datetime'"
                placeholder="选择时间"
                v-model="form[item.prop]"
                :style="{ width: item.width || '300px' }"
                :value-format="item.format || ''"
              ></el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item v-if="!item.isHidden && item.type === 'el-switch'" :label="item.label" :prop="item.prop">
            <el-switch
              v-model="form[item.prop]"
              :active-text="item.activeText"
              :inactive-text="item.inactiveText"
              :active-value="item.activeValue"
              :inactive-value="item.inactiveValue"
              @change="changeSwitch($event, item)"
            ></el-switch>
          </el-form-item>
          <el-form-item v-if="item.type === 'el-radio'" :label="item.label" :prop="item.prop">
            <el-radio-group v-model="form[item.prop]">
              <el-radio v-for="(optionItem, optionIndex) of item.options" :key="optionIndex" :label="optionItem.label">
                {{ optionItem.text }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="item.type === 'el-input-textarea'" :label="item.label" :prop="item.prop">
            <el-input
              type="textarea"
              v-model="form[item.prop]"
              :placeholder="item.placeholder"
              :style="{ width: item.width || '300px' }"
              :maxlength="item.maxlength"
              :show-word-limit="item.showWordLimit"
              :autosize="item.autoSize"
              :rows="item.rows ? item.rows : 2"
              @input="handleTextarea"
              @keyup.native="handleEnter"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="!item.isHidden && item.type === 'el-button'" :label="item.label" :prop="item.prop">
            <el-button type="primary" @click="item.callback && item.callback(item.prop)">{{ item.buttonText }}</el-button>
          </el-form-item>
          <!-- 单个文件上传 - 此版本是返回file文件 接口需要上传file时调用 -->
          <el-form-item v-if="!item.isHidden && item.type === 'el-upload-file'" :label="item.label" :prop="item.prop">
            <el-upload
              v-model="form[item.prop]"
              :show-file-list="true"
              ref="uploadFile"
              list-type="picture-list"
              :action="item.action"
              :multiple="false"
              :limit="1"
              :before-upload="handleFileProgress(item.prop)"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传excel文件 xls xlsx csv格式</div>
              <div slot="tip" class="el-upload__tip" v-show="!!fileName">{{ '当前选择的文件：' + fileName }}</div>
            </el-upload>
          </el-form-item>
          <!-- 单个文件上传 - 自动上传服务器 返回链接版本 -->
          <el-form-item v-if="!item.isHidden && item.type === 'el-upload-file-auto'" :label="item.label" :prop="item.prop">
            <el-upload
              :action="upLoadUrlAdmin"
              :headers="headersObj"
              :multiple="false"
              :limit="1"
              :show-file-list="true"
              :file-list="autoFileList"
              :on-remove="
                (file, fileList) => {
                  handleAutoFileRemove(item.prop);
                }
              "
              :on-success="
                (res, file) => {
                  handleAutoFileSuccess(item.prop, res);
                }
              "
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <!-- 单个图片上传 -->
          <el-form-item v-if="item.type === 'el-upload-image'" :label="item.label" :prop="item.prop">
            <el-upload
              class="avatar-uploader"
              style="display: inline-block"
              drag
              :action="upLoadUrl"
              :headers="headersObj"
              :show-file-list="false"
              :before-upload="handleBeforeUpload"
              :on-change="handleImageProgress"
              :on-success="
                (res, file) => {
                  handleImageSuccess(item.prop, res);
                }
              "
            >
              <img v-if="form[item.prop]" class="avatar" :src="form[item.prop]" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <!-- 多张图片上传 -->
          <el-form-item v-if="item.type === 'el-upload-image-list'" :label="item.label" :prop="item.prop">
            <el-upload
              class="multiple-drags"
              :action="upLoadUrl"
              :file-list="getStableImageFileList(item.prop, form[item.prop])"
              :headers="headersObj"
              multiple
              :limit="item.maximum"
              drag
              list-type="picture"
              :on-preview="handlePreview"
              :on-change="
                (file, fileList) => {
                  handleImageListChange(item, file, fileList);
                }
              "
              :on-exceed="
                (files, fileList) => {
                  handleImageListExceed(item, files, fileList);
                }
              "
              :on-remove="
                (file, fileList) => {
                  handleRemove(item, file, fileList);
                }
              "
              :on-success="
                (res, file, fileList) => {
                  handleImageListSuccess(item, res, file, fileList);
                }
              "
              :on-error="
                (error, file, fileList) => {
                  handleImageListError(item, error, file, fileList);
                }
              "
            >
              <el-button size="small" type="primary" style="margin-top: 20px">点击/拖拽</el-button>
              <div slot="tip" class="el-upload__tip">{{ item.tips }}</div>
            </el-upload>
          </el-form-item>
          <!-- 图片左右查看 -->
          <el-form-item v-if="item.type === 'el-image-swiper'" :label="item.label" :prop="item.prop">
            <swiper v-if="form[item.prop] && form[item.prop].length" ref="mySwiper" :options="swiperOption" style="width: 400px; margin-left: 0">
              <swiper-slide v-for="(item, index) of form[item.prop]" :key="index">
                <!-- <img style="width: 400px; height: auto" :src="item" /> -->
                <el-image style="width: 400px; height: auto" :src="item" :preview-src-list="[item]" :z-index="4000"></el-image>
              </swiper-slide>
              <div v-if="item.showPagination" class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </el-form-item>
          <!-- 2022.01.10新增 树形组件 -->
          <el-form-item v-if="!item.isHidden && item.type === 'el-tree-select'" :label="item.label">
            <SelectTree
              ref="selecttree"
              :value="form[item.prop]"
              :options="item.options"
              @change="
                (val) => {
                  form[item.prop] = val;
                }
              "
            ></SelectTree>
          </el-form-item>
        </div>
        <el-form-item :style="{ marginLeft: btnMarginLeft, marginTop: '50px' }" label-width="100px">
          <el-button size="small" @click="resetForm('form')" v-if="isReset">重置</el-button>
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button type="primary" size="small" @click="submitForm('form')">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import BASE_API from '@/config';
import { getToken } from '@/utils/localStorage.js';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import SelectTree from './SelectTree.vue';
import { appendImageInSelectionOrder, imageUploadMixin, normalizeImageList, removeImageByUploadFile } from '@/utils/imageUpload.js';

export default {
  mixins: [imageUploadMixin],
  components: {
    Swiper,
    SwiperSlide,
    SelectTree,
  },
  directives: {
    swiper: directive,
  },
  props: {
    dialogTitle: {
      type: String,
      default: '',
    },
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    dialogModel: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isReset: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Object,
      default: () => {
        return {};
      },
    },
    customTop: {
      type: String,
      default: '15vh',
    },
    dialogWidth: {
      type: String,
      default: '650px',
    },
    btnMarginLeft: {
      type: String,
      default: '260px',
    },
    swiperImgList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: {}, // 表单中数据
      images: 'images', // 表单中图片key值
      uploadImageProp: '', // 上传图片的prop
      uploadImagePropOne: '', // 上传图片的prop(如果需要上传两张图片)
      isfrequently: false,
      fileName: '',
      upLoadUrl: BASE_API + 'admin/work_upload', // 此接口只可上传图片
      upLoadUrlAdmin: BASE_API + 'admin/work_upload_admin',
      headersObj: {
        Authorization: 'Bearer ' + getToken(),
      },
      imgList: [],
      autoFileList: [],
      swiperOption: {
        width: 400,
        height: 400,
        pagination: {
          el: '.swiper-pagination',
        },
      },
    };
  },
  methods: {
    // 文本框输入处理
    handleTextarea(val) {
      this.$emit('handleTextarea', val);
    },
    handleEnter(event) {
      let e = event || window.event;
      if (e.key == 'Enter' || e.code == 'Enter' || e.keyCode == 13) {
        e.returnValue = false;
        e.preventDefault();
        return false;
      }
    },
    // 重置表单
    resetForm() {
      this.resetDialogImageUploads();
      this.form = {};
      this.autoFileList = [];
      this.$refs['selecttree'] && this.$refs['selecttree'][0].resetData();
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    // 编辑表单
    editForm(row) {
      this.resetDialogImageUploads();
      this.form = row;
      this.normalizeDialogImageLists();
    },
    // 设置form值
    setForm(e) {
      this.resetDialogImageUploads();
      let keys = Object.keys(e);
      for (const key of keys) {
        this.$set(this.form, key, e[key]);
      }
      this.normalizeDialogImageLists();
    },
    // 关闭对话框
    closeDialog() {
      this.resetDialogImageUploads();
      this.$emit('closeDialog');
    },
    // 选择游戏圈选项成功后
    changeOption(value, item) {
      item.callback && item.callback(value);
    },
    // 提交表单
    async submitForm(formName) {
      if (!this.guardImageUploads(this.imageListScopes())) return;
      this.$emit('submitForm', this.form);
    },
    // 改变input后触发函数
    changeInput($event, item) {
      if (this.form.rate) {
        let count = 0;
        if (!this.form.count || this.form.count == '0') {
          count = 0;
        } else {
          count = 1;
        }
        this.form.real_rate = this.form.rate * count;
      }
      item.callback && item.callback($event);
    },
    // 改变switch后触发函数
    changeSwitch($event, item) {
      item.callback && item.callback($event);
    },
    // 修改form表单中的值
    changeFormValue(item) {
      Object.assign(this.form, item);
    },
    handleFileProgress(key) {
      return (file) => {
        console.log(file);
        this.fileName = file.name;
        this.$set(this.form, key, file);
        return false;
      };
    },
    // 图片上传前
    handleBeforeUpload() {},
    // 图片上传中
    handleImageProgress() {},
    // 图片上传成功
    handleImageSuccess(prop, res) {
      this.$set(this.form, prop, res.path);
    },
    // 自动上传文件上传成功
    handleAutoFileSuccess(prop, res) {
      this.$set(this.form, prop, res.data.path);
    },
    // 自动上传文件删除文件
    handleAutoFileRemove(prop) {
      // 因为是单个文件 直接删除
      this.$set(this.form, prop, undefined);
      this.autoFileList = [];
    },
    // 多张图片上传成功回调
    handleImageListSuccess(item, res, file, fileList) {
      const prop = item.prop;
      if (!this.isCurrentImageUpload(prop, file)) return;
      if (!this.form[prop]) {
        this.$set(this.form, prop, []);
      }
      if (res.code !== 200 || !res.path) {
        this.trackImageUpload(prop, Object.assign(file, { status: 'fail' }), fileList);
        this.$message.error(res.message || '图片上传失败');
        return;
      }
      this.$set(this.form, prop, appendImageInSelectionOrder(this.form[prop], file, { url: res.path, name: res.name || file.name }));
      this.trackImageUpload(prop, file, fileList);
    },
    handleImageListChange(item, file, fileList) {
      this.trackImageUpload(item.prop, file, fileList);
    },
    handleImageListError(item, error, file, fileList) {
      if (!this.isCurrentImageUpload(item.prop, file)) return;
      this.trackImageUpload(item.prop, file, fileList);
      this.$message.error(`${file.name || '图片'}上传失败`);
    },
    handleImageListExceed(item, files, fileList) {
      if (item.maximum) this.handleImageUploadExceed(item.maximum, files, fileList);
    },
    // 预览图片
    handlePreview() {},
    // 移除图片
    handleRemove(item, file, fileList) {
      this.$set(this.form, item.prop, removeImageByUploadFile(this.form[item.prop], file));
      this.removeTrackedImage(item.prop, file, fileList);
    },
    imageListScopes() {
      return this.dialogModel.filter((item) => item && item.type === 'el-upload-image-list').map((item) => item.prop);
    },
    normalizeDialogImageLists() {
      this.imageListScopes().forEach((prop) => {
        if (this.form[prop]) this.$set(this.form, prop, normalizeImageList(this.form[prop], prop));
      });
    },
    resetDialogImageUploads() {
      this.imageListScopes().forEach((scope) => this.resetImageUploadScope(scope));
    },
  },
};
</script>

<style lang='less' module>
.arrow {
  position: absolute;
  top: 35px;
  right: 60px;
  z-index: 999;
  color: red;
}
.el-upload--text {
  background-color: pink;
}
</style>
<style>
.avatar-uploader .el-upload {
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 150px;
  height: 150px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 145px;
  line-height: 145px;
}
.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
.el-upload-list {
  width: 300px;
}
</style>
